import axiosIns from '@/libs/axios'

const ROOT_URL = '/coins'

export default {
  namespaced: true,
  state: {
    dataList: [],
    metaData: {
      total: 0,
      page: 1,
      limit: 50,
      totalPages: 0,
    },
    syncResult: null,
    dataSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    dataList(state) {
      return state.dataList
    },
    metaData(state) {
      return state.metaData
    },
    syncResult(state) {
      return state.syncResult
    },
    dataSaveStatus(state) {
      return state.dataSave
    },
  },
  mutations: {
    SET_DATA_LIST(state, data) {
      state.dataList = data
    },
    SET_META_DATA(state, data) {
      state.metaData = data
    },
    SET_SYNC_RESULT(state, data) {
      state.syncResult = data
    },
    SET_DATA_SAVE(state, data) {
      state.dataSave = data
    },
  },
  actions: {
    getDataList({ commit }, params) {
      return axiosIns
        .post(ROOT_URL, params)
        .then(response => {
          commit('SET_DATA_LIST', response.data.data)
          commit('SET_META_DATA', response.data.meta)
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Coin listesi alınamadı.' })
        })
    },
    syncCoins({ commit }, body) {
      return axiosIns
        .post(`${ROOT_URL}/sync`, body || { providerKind: 'BINANCE' })
        .then(response => {
          commit('SET_SYNC_RESULT', response.data.data)
          commit('SET_DATA_SAVE', { status: true, message: 'Coin sync tamamlandı.' })
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Sync sırasında hata oluştu.' })
        })
    },
    toggleActive({ commit }, { id, isActive }) {
      return axiosIns
        .patch(`${ROOT_URL}/${id}/active`, { isActive })
        .then(response => {
          commit('SET_DATA_SAVE', {
            status: true,
            message: response.data.message || `${isActive ? 'Aktif' : 'Pasif'} yapıldı.`,
          })
        })
        .catch(error => {
          console.error(error)
          commit('SET_DATA_SAVE', { status: false, message: 'Durum değiştirilemedi.' })
        })
    },
  },
}
